export const iconFontAwesomeSportsFitnessMedal = (
	<i className="fa-solid fa-medal"></i>
);
